import { render, staticRenderFns } from "./BaseRadioList.vue?vue&type=template&id=2ff2def2"
import script from "./BaseRadioList.vue?vue&type=script&lang=js"
export * from "./BaseRadioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports